import Vue from 'vue'

import VueRouter from 'vue-router'

const req = require.context('./components', true, /route\.js?$/);
const allRoutes = [].concat(...req.keys().map(k => req(k).default));
Vue.use(VueRouter);

const routes = [
  ...allRoutes,
  {
    path: '*',
    // hidden: true,
    redirect: { path: '/homepage' }
  }
];

const router = new VueRouter({
  routes, //缩写:相当于 routes: routes

  scrollBehavior(to,from,savedPosition){
    if(savedPosition){
      return savedPosition;
    }else{
      return {x:0,y:0}
    }
  },
  // scrollBehavior(to, from, savedPosition) {
  //   if (to.name === 'trading' && localStorage.getItem("tradingScrollY") && from.name != null) {
  //     // console.log(localStorage.getItem("tradingScrollY"))
  //     return {x: 0, y: parseInt(localStorage.getItem("tradingScrollY"))}
  //   } else if (savedPosition) {
  //     return savedPosition
  //   }
  //   // return {x: 0, y: 0}
  // }
});

export default router;
